import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="page-hero">
        <div className="container">
          <h1>About SCE Automated</h1>
          <p className="page-hero-subtitle">
            Leading the future of industrial automation
          </p>
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          <div className="content-block">
            <h2>Our Story</h2>
            <p>
              SCE Automated has been at the forefront of industrial automation for years, 
              delivering innovative solutions that transform manufacturing operations. We 
              combine deep technical expertise with a commitment to excellence, helping 
              companies achieve greater efficiency, quality, and competitiveness.
            </p>
            <p>
              Our multidisciplinary team brings together Mechanical Designers, Controls 
              Electrical Engineers, and Software Engineers with decades of combined experience. 
              This unique combination allows us to handle complete machines and production 
              lines from scratch, as well as provide specialized services including controls 
              commissioning (Rockwell, Siemens, Beckhoff, Bosch) and custom software projects.
            </p>
            <p>
              We understand the unique challenges manufacturers face and develop solutions 
              that are both technically advanced and practically implementable, delivering 
              end-to-end automation solutions that drive real business value.
            </p>
          </div>

          <div className="content-block">
            <h2>Our Mission</h2>
            <p>
              To empower manufacturers with cutting-edge automation solutions that drive 
              operational excellence, improve product quality, and enhance competitive 
              advantage in today's dynamic marketplace.
            </p>
          </div>

          <div className="content-block">
            <h2>Our Vision</h2>
            <p>
              To be the trusted partner of choice for manufacturers seeking innovative 
              automation solutions, recognized for our technical excellence, reliability, 
              and commitment to customer success.
            </p>
          </div>

          <div className="content-block">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Excellence</h3>
                <p>We strive for the highest standards in everything we do, from design to implementation.</p>
              </div>
              <div className="value-item">
                <h3>Innovation</h3>
                <p>We embrace new technologies and methodologies to deliver cutting-edge solutions.</p>
              </div>
              <div className="value-item">
                <h3>Integrity</h3>
                <p>We conduct business with honesty, transparency, and ethical practices.</p>
              </div>
              <div className="value-item">
                <h3>Partnership</h3>
                <p>We build long-term relationships based on trust, collaboration, and mutual success.</p>
              </div>
            </div>
          </div>

          <div className="content-block">
            <h2>Our Capabilities</h2>
            <div className="capabilities-grid">
              <div className="capability-item">
                <h3>Complete Solutions</h3>
                <p>Design and build machines and production lines from scratch with our integrated team of Mechanical Designers, Controls Engineers, and Software Engineers</p>
              </div>
              <div className="capability-item">
                <h3>Controls Commissioning</h3>
                <p>Expert commissioning services for Rockwell (Allen-Bradley), Siemens, Beckhoff, and Bosch control systems</p>
              </div>
              <div className="capability-item">
                <h3>Robotics Expertise</h3>
                <p>Integration and programming of Fanuc, Kuka, ABB, Epson, Denso, Yaskawa, and Staubli robots</p>
              </div>
              <div className="capability-item">
                <h3>Software Development</h3>
                <p>Custom software projects including SCADA systems (Ignition), .NET solutions, and web applications (React + Node.js)</p>
              </div>
            </div>
          </div>

          <div className="content-block">
            <h2>Why Choose Us</h2>
            <div className="features-list">
              <div className="feature-item">
                <h3>Multidisciplinary Team</h3>
                <p>Mechanical Designers, Controls Electrical Engineers, and Software Engineers working together</p>
              </div>
              <div className="feature-item">
                <h3>End-to-End Solutions</h3>
                <p>From concept to commissioning, we handle complete automation projects</p>
              </div>
              <div className="feature-item">
                <h3>Quality Assurance</h3>
                <p>Rigorous testing and validation processes ensure reliable performance</p>
              </div>
              <div className="feature-item">
                <h3>Global Support</h3>
                <p>USA-based with support capabilities across North America, Central & South America, and Europe</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

